module.exports = __webpack_public_path__ + "static/img/icon_2lh.4f17150.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/advantage/icon_2lh.jpg
// module id = EJUv
// module chunks = 0